import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService, ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';
import { SetupItems } from '../models/setupItems';

@Injectable({
  providedIn: 'root'
})
export class ClayService extends ServiceBase{

  constructor(private http: HttpClient,
    authService: AuthService) {
    super(authService);
  }

  public getAllClays(artTypeId: string | null = null): Observable<SetupItems[]> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/Clay';
    const method: string = '/fetch';
    var url: string = environment.BASE_API_PATH + api + method;
    
    if (artTypeId) {
      url += '/' + artTypeId;
    }
    return this.http.get<SetupItems[]>(url, httpOptions);
  }
  
  public saveMaterial(clay: SetupItems): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/Clay';
    const method: string = '/save';
    const url: string = environment.BASE_API_PATH + api + method ;
    return this.http.post<ResponseObject>(url, clay, httpOptions);
  }



  public deleteMaterial(Id: string): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/Clay';
    const method: string = '/deleteClay/';
    const url: string = environment.BASE_API_PATH + api + method + Id;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }

  public excludeClay(Id: string): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/Clay';
    const method: string = '/exclude/';
    const url: string = environment.BASE_API_PATH + api + method + Id;
    return this.http.post<ResponseObject>(url, httpOptions);
  }
}
